import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ObjetoPrensa } from '../../model/ObjetoPrensa';
import { DomSanitizer } from '@angular/platform-browser';
import { PrensaService } from '../../services/prensa.service';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-prensa',
  imports: [CommonModule, MatCardModule, RouterModule, MatProgressSpinnerModule],
  templateUrl: './prensa.component.html',
  styleUrl: './prensa.component.scss'
})
export class PrensaComponent {
  notas: ObjetoPrensa[] = [];
  showSpinner: boolean = true;
  constructor(private service: PrensaService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.service.getNotas(0).subscribe(result => {
      this.notas = result.items;
      this.showSpinner = false;
    });
  }
}
